module.exports = __webpack_public_path__ + "img/a13.01eb12a4.png";